"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LogOut_exports = {};
__export(LogOut_exports, {
  default: () => LogOut_default
});
module.exports = __toCommonJS(LogOut_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13 1.91016C13.2344 1.91016 13.4297 1.99479 13.5859 2.16406C13.7552 2.32031 13.8398 2.51562 13.8398 2.75V6.5C13.8398 6.61719 13.7943 6.71484 13.7031 6.79297C13.625 6.87109 13.5273 6.91016 13.4102 6.91016C13.293 6.91016 13.1953 6.87109 13.1172 6.79297C13.0391 6.71484 13 6.61719 13 6.5V2.75H3.83984L8.37109 5.01562C8.51432 5.09375 8.625 5.19792 8.70312 5.32812C8.79427 5.45833 8.83984 5.60156 8.83984 5.75781V15.25H13V12.3203C13 12.2031 13.0391 12.1055 13.1172 12.0273C13.1953 11.9492 13.293 11.9102 13.4102 11.9102C13.5273 11.9102 13.625 11.9492 13.7031 12.0273C13.7943 12.1055 13.8398 12.2031 13.8398 12.3203V15.25C13.8398 15.4714 13.7552 15.6667 13.5859 15.8359C13.4297 15.9922 13.2344 16.0703 13 16.0703H8.83984V17.75C8.83984 17.9844 8.75521 18.1862 8.58594 18.3555C8.42969 18.5117 8.23438 18.5898 8 18.5898C7.94792 18.5898 7.89583 18.5833 7.84375 18.5703C7.80469 18.5573 7.75911 18.5443 7.70703 18.5312L2.62891 16.3047C2.48568 16.2396 2.36849 16.1419 2.27734 16.0117C2.19922 15.8685 2.16016 15.7188 2.16016 15.5625V2.75C2.16016 2.51562 2.23828 2.32031 2.39453 2.16406C2.5638 1.99479 2.76562 1.91016 3 1.91016H13ZM3 3.25781V15.5625L8 17.75V5.75781L3 3.25781ZM16.1055 5.50391L16.1641 5.58203L18.6641 8.92188L18.7031 8.96094L18.7617 9.07812L18.8008 9.17578L18.8203 9.27344L18.8398 9.37109V9.48828L18.8203 9.54688L18.8008 9.64453L18.7617 9.74219L18.7422 9.80078L18.6836 9.89844L16.1641 13.2578L16.1055 13.3359C15.9622 13.4792 15.7799 13.5638 15.5586 13.5898C15.3503 13.6029 15.1615 13.5443 14.9922 13.4141C14.8229 13.2839 14.7188 13.1211 14.6797 12.9258C14.6406 12.7174 14.6732 12.5221 14.7773 12.3398L14.8359 12.2422L16.3398 10.25H11.3398C11.1055 10.25 10.9036 10.1719 10.7344 10.0156C10.5781 9.84635 10.5 9.64453 10.5 9.41016C10.5 9.20182 10.5716 9.01953 10.7148 8.86328C10.8581 8.70703 11.0339 8.61589 11.2422 8.58984H11.3398H16.3398L14.8359 6.57812C14.6927 6.39583 14.6341 6.19401 14.6602 5.97266C14.6992 5.73828 14.8099 5.55599 14.9922 5.42578C15.1615 5.29557 15.3503 5.24349 15.5586 5.26953C15.7799 5.28255 15.9622 5.36068 16.1055 5.50391Z",
      fill: "currentColor"
    }
  )
);
const SvgLogOut = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var LogOut_default = SvgLogOut;
